module.exports = __webpack_public_path__ + "static/flags/SM-265dd26e72ef21defcfde96d2038049a.gif";